export const formatarCPFCNPJ = (valor: string): string => {
    if (!valor) return ''
    const numeros = valor.replace(/\D/g, '');
    const ehCPF = numeros.length === 11;

    if (ehCPF) {
        return numeros.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
    }

    return numeros.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
}

export const formatarRG = (valor: string): string => {
    if (!valor) return ''
    const numeros = valor.replace(/\D/g, '');
    if (numeros.length > 9) {
        // Limita ao máximo de 9 dígitos (8+1)
        const rg = numeros.slice(0, 9);
        return rg.replace(/(\d{2})(\d{3})(\d{3})(\d{1})/, '$1.$2.$3-$4');
    } else if (numeros.length > 8) {
        return numeros.replace(/(\d{2})(\d{3})(\d{3})(\d{1})/, '$1.$2.$3-$4');
    } else if (numeros.length > 5) {
        return numeros.replace(/(\d{2})(\d{3})(\d{0,3})/, '$1.$2.$3');
    } else if (numeros.length > 2) {
        return numeros.replace(/(\d{2})(\d{0,3})/, '$1.$2');
    }
    return numeros;
}

export const formatarIncra = (valor: string): string => {
    if (!valor) return ''
    const numeros = valor.replace(/\D/g, '').slice(0, 13); // Limita ao máximo de 13 caracteres
    return numeros.replace(/(\d{3})(\d{3})(\d{3})(\d{3})(\d{1})/, '$1.$2.$3.$4/$5');
};

export const formatarNirf = (valor: string): string => {
    if (!valor) return ''
    const numeros = valor.replace(/\D/g, '').slice(0, 8); // Limita ao máximo de 8 caracteres
    return numeros.replace(/(\d{7})(\d{1})/, '$1-$2');
};

export const formatarValorMonetario = (valor: number | string): string => {
    const numero = typeof valor === 'string' ? parseFloat(valor) : valor;

    if (isNaN(numero)) {
        return 'Valor inválido';
    }

    const valorFormatado = numero.toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL',
        minimumFractionDigits: 2,
    });

    return valorFormatado;
}

export const formatarTelefone = (valor: string): string => {
    if (!valor) return ''
    let numeros = valor.replace(/\D/g, '');
    const tamanho = numeros.length;

    if (tamanho > 11) {
        numeros = numeros.substring(0, 11);
    }

    if (tamanho <= 2) {
        return numeros;
    } else if (tamanho <= 6) {
        return `(${numeros.substring(0, 2)}) ${numeros.substring(2)}`;
    } else if (tamanho <= 10) {
        return `(${numeros.substring(0, 2)}) ${numeros.substring(2, 6)}-${numeros.substring(6)}`;
    } else {
        return `(${numeros.substring(0, 2)}) ${numeros.substring(2, 7)}-${numeros.substring(7)}`;
    }
};

export const permitirApenasNumerosOuSN = (valor: string)=> {
    valor = valor.trim().toUpperCase();
    if (/^\d+$/.test(valor) || valor === 'S' || valor === 'N') {
        return valor;
    }
    return "";
}

export const permitirApenasNumeros = (valor: string): string => {
    if (!valor) return ''
    return valor.replace(/\D/g, '');
};

export const formatarCEP = (cep: string): string => {
    if (!cep) return ''
    cep = cep.replace(/\D/g, '');

    if (cep.length > 5) {
        cep = cep.substring(0, 5) + '-' + cep.substring(5, 8);
    }

    return cep;
};

export const formatarCPF = (value: string) => {
    if (!value) return '';
    const cleanedValue = value.replace(/\D/g, '');

    return cleanedValue.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
}

export const formatarCNPJ = (value: string) => {
    if (!value) return '';
    const cleanedValue = value.replace(/\D/g, '');

    return cleanedValue.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
}

export const formatarNumero = (numero: number) => {
    return numero.toLocaleString('pt-BR', { minimumFractionDigits: 1 });
}

export const formatarDecimal = (value: string, casas: number = 2) => {
    const num = parseFloat(value);
    
    const formattedNum = new Intl.NumberFormat('pt-BR', {
        minimumFractionDigits: casas,
        maximumFractionDigits: casas
    }).format(num);
    return formattedNum
}

export const formatarDecimalNumber = (value: number, casas: number = 2) => {
    const formattedNum = new Intl.NumberFormat('pt-BR', {
        minimumFractionDigits: casas,
        maximumFractionDigits: casas
    }).format(value);
    return formattedNum
}

export const formatarBooleano = (value: number, inverter: boolean = false) => {
    let formatValue = Boolean(value)
    if(inverter) formatValue = !formatValue
    return formatValue ? "Sim" : "Não"
}

export function formatarDataBR(valor: string): string {
    if (typeof valor !== "string") return valor;

    const match = valor.match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (!match) return valor;

    const [, ano, mes, dia] = match;
    return `${dia}/${mes}/${ano}`;
}
//Inputs masks

export const formatarInputValorMonetário = (valor: string) => {
    const formatter = new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL'
    });

    const numero = valor.replace(/[^\d]/g, '');
    const numeroFormatado = Number(numero) / 100;
    return formatter.format(numeroFormatado)
}

export const formatarInputCPF = (valor: string): string => {
    valor = valor.replace(/\D/g, '');
    if (valor.length > 11) {
        valor = valor.slice(0, 11);
    }
    valor = valor.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');

    return valor;
}

export const formatarInputValorMonetárioSemPrefixo = (valor: string | number) => {
    const formatter = new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL',
    });

    const numero = valor.toString().replace(/[^\d]/g, '');
    const numeroFormatado = Number(numero) / 100;
    const valorFormatado = formatter.format(numeroFormatado);

    // Remove o prefixo "R$"
    return valorFormatado.replace('R$', '').trim();
}

export const formatarMonetárioParaNúmero = (valor: string): number => { 
    // Remove todos os caracteres não numéricos exceto a vírgula
    const valorSemFormatacao = valor.replace(/[^\d,]/g, '');
    
    // Substitui a vírgula por um ponto
    const valorComPontoDecimal = valorSemFormatacao.replace(',', '.');
    
    // Converte para número
    return parseFloat(valorComPontoDecimal);
}

export const formatarInputDecimal = (valor: string, casas: number = 2): string => {
    // Remove tudo que não for dígito
    const numero = valor.replace(/[^\d]/g, '');
  
    // Adiciona zeros à esquerda se necessário para garantir que temos ao menos 'casas' dígitos
    const numeroComZeros = numero.padStart(casas + 1, '0');
  
    // Divide a parte inteira da parte decimal
    const parteInteira = numeroComZeros.slice(0, -casas);
    const parteDecimal = numeroComZeros.slice(-casas);
  
    // Junta com vírgula e formata com Intl
    const numeroFormatado = `${parteInteira},${parteDecimal}`;
  
    // Converte para número e formata com Intl
    const formatter = new Intl.NumberFormat('pt-BR', {
      minimumFractionDigits: casas,
      maximumFractionDigits: casas,
    });
  
    return formatter.format(Number(numeroFormatado.replace(',', '.')));
  };

 export const formatarPorcentagem = (valor: string): string => {
  const numeros = valor.replace(/\D/g, '');
  
  if (!numeros) return '0,00';
  
  // Converte para número e divide por 100 para ter casas decimais
  let numero = parseInt(numeros) / 100;
  
  // Limita a 100
  if (numero > 100) {
    numero = 100;
  }
  
  // Formata com 2 casas decimais usando vírgula
  return numero.toLocaleString('pt-BR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
};

// Função para converter string formatada para número
export const porcentagemParaNumero = (valor: string): number => {
  return parseFloat(valor.replace(',', '.')) || 0;
};

export const formatCurrencyCategory = (value: string) => {
    const numeric = value.replace(/\D/g, "");

    if (!numeric) return "";

    const number = (parseInt(numeric, 10) / 100).toFixed(2);

    return number
        .replace(".", ",")
        .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
};

export const formatarNumeroComSeparadorMilhar = (valor: number | string): string => {
    // Converte para número se for string
    const numero = typeof valor === 'string' ? parseFloat(valor.replace(/\D/g, '')) : valor;
    
    // Valida se é um número válido
    if (isNaN(numero)) {
        return '';
    }
    
    // Formata com separador de milhares (ponto) no padrão brasileiro
    return numero.toLocaleString('pt-BR', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
    });
};